import { render } from "./Qiandao.vue?vue&type=template&id=4b3c7c33&scoped=true"
import script from "./Qiandao.vue?vue&type=script&lang=js"
export * from "./Qiandao.vue?vue&type=script&lang=js"

import "./Qiandao.vue?vue&type=style&index=0&id=4b3c7c33&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3c7c33"]])

export default __exports__